import { createClient } from 'https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2/+esm';

export function initSupabase(url, anonKey) {
  if (!url || !anonKey) return null;
  return createClient(url, anonKey);
}
